import { combineReducers } from 'redux';

import auth from './auth/reducers';

export default combineReducers({ auth });
